export default {
  about:{
    title: 'Acerca de Nosotros',
    description: 'Somos una firma de consultores de alto nivel con amplia experiencia en negocios, auditoría, impuestos, finanzas y asuntos legales en el área empresarial.',
    subdescription: 'Brindamos asesoría profesional para impulsar negocios exitosos solucionando problemas de una manera creativa y diferente; desde un punto de vista joven e innovador, proporcionamos estrategias adecuadas al contexto de un mercado actual globalizado.',
    conformados: 'Como estamos conformados',
  },
  filtereditem: {
    0: {
      title: 'Socios',
      items: [
        {name:'- Socio Director'},
        {name:'- Socio Consultoría, Auditoría e Impuestos'},
        {name:'- Socio Gerente'},
        {name:'- Socio Legal'},
        {name:'- Socio Impuestos y Precios de Transferencia México y Regional'},
      ]
    },
    1: {
      title: 'Gerentes',
      items: [
        {name:'- Auditoría'},
        {name:'- Consultoría'},
        {name:'- Impuestos'},
        {name:'- Tecnología y Sistemas'},
      ]
    },
    2: {
      title: 'Staff',
      items: [
        {name:'- Auditoría'},
        {name:'- Legal'},
        {name:'- Consultoría, tecnología y sistemas'},
        {name:'- Impuestos'}
      ]
    },
    3: {
      title: 'administración',
      items: [
        {name:'- Gerente Administrativa y Financiera'},
        {name:'- Gerente de Recursos Humanos'},
      ]
    }
  },
  partners:
  {
    title: 'Nuestros Socios',
    list:[
      {
        name:'Lic. Jorge A. Román García.',
        dep: 'Socio Director.',
        description: 'Jorge Román García es auditor y consultor con más de 40 años de trayectoria profesional. Trabajó como gerente de auditoría en la firma Peat Marwick & Mitchel mejor conocido como KPMG, lugar donde estuvo doce años y donde se consolidó como el instructor para Latinoamérica para KPMG internacional.',
        description2: 'Es el fundador de Román & Román Consultores. En la actualidad, es el encargado del control calidad de toda la firma, su amplia experiencia hace que los altos estándares de profesionalismo, principios y valores sean bien definidos para sus clientes y su equipo de trabajo.',
        description3: 'Nuestro socio director cuenta con amplia experiencia en las empresas comerciales, inmobiliarias, agro-comerciales, textiles, cafetaleras, aseguradoras, de servicios, financieras, organizaciones sin fines de lucro, entre otras.'
      },
      {
        name:'Licda. Doris Román de Amado.',
        dep: 'Socio Gerente.',
        description: 'Doris Román de Amado cuenta con más de 20 años de trayectoria profesional en traducción jurada (inglés-español), es egresada del Instituto Femenino de Estudios Superiores IFES, certificada ante el Ministerio de Educación y la Embajada Americana en Guatemala.',
        description2: 'Su carrera se ha desarrollado en la firma Román & Román Consultores.',
        description3: 'Tiene una amplia experiencia en traducciones inglés-español, español-inglés, enfocada a manuales, folletos, documentos legales, informes, entre otros.'
      },
      {
        name:'Lic. Jorge Roman Pineda.',
        dep: 'Socio de Consultoría, Auditoría e Impuestos.',
        description: 'Jorge Román Pineda tiene 18 años de trayectoria profesional como auditor y consultor, iniciando su carrera profesional en la firma Román & Román Consultores.',
        description2: 'Su formación profesional incluye brindar servicios de consultoría y capacitación a corporaciones e industrias, sobre la administración del riesgo de fraude, su prevención y detección, atendiendo a distintas compañías aseguradoras para brindar servicio a sus clientes por reclamo de siniestros de esa naturaleza.',
        description3: 'Nuestro socio se ha desempeñado profesionalmente en las empresas financieras, aseguradoras, textiles, agro-comerciales, sin fines de lucro y de servicios.'
      },
      {
        name:'Lic. Ernesto Figueroa.',
        dep: 'Socio de Precios de Transferencia.',
        description: 'Ernesto Figueroa es Contador Público y Abogado, tiene 12 años de trayectoria profesional en la República de los Estados Unidos Mexicanos, desarrollándose profesionalmente en la firma RSM (Bogarin y Asociados, México Guadalajara), posteriormente forma su propio despacho de consultores y se asocia comercialmente con Román & Román Consultores desde el año 2014.',
        description2: '',
        description3: 'Ernesto se desempeña en asesoramiento y creación de compañías mercantiles, además de prestar el servicio de Estudios de Precios de Transferencia.'
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/text/es/about.js